<template>
  <div>
    <cards-select-modal
      ref="cardSelectModal"
      @card-selected="cardSelected"
    ></cards-select-modal>

    <clone-elements-from-card-modal
      ref="cloneElementsSelectModal"
      :card-id="cardIdToCloneFrom"
      @elements-cloned="$emit('elements-cloned')"
    >
    </clone-elements-from-card-modal>

    <span ref="wrapper">
      <slot name="reference"></slot>
    </span>
  </div>
</template>

<script>

import { off, on } from "element-ui/src/utils/dom";
import CardsComponent from "@/components/cards/CardsComponent";
import CardsSelectModal from "@/components/cards/CardSelectModal.vue";
import CloneElementsFromCardModal from "@/components/cards/CloneElementsFromCardModal.vue";

export default {
  name: "cards-select-and-clone-elements-modal",
  components: {CloneElementsFromCardModal, CardsSelectModal, CardsComponent},
  props: {

  },

  data() {
    return {
      cardIdToCloneFrom: null,
    }
  },
  mounted() {
    if (this.$refs.wrapper.children) {
      on(this.$refs.wrapper.children[0], 'click', this.showCardSelectModal);
    }
  },
  beforeDestroy() {
    if (this.$refs.wrapper.children) {
      off(this.$refs.wrapper.children[0], 'click', this.showCardSelectModal);
    }
  },
  methods: {
    showCardSelectModal() {
      this.$refs.cardSelectModal.show = true;
    },

    async cardSelected(card){
      console.log(card);
      this.cardIdToCloneFrom = card.id;
      await this.$nextTick();
      this.$refs.cloneElementsSelectModal.showCard();
      // this.$emit('card-selected', card);
      // this.show = false;
    }

  },



}
</script>

<style>
.CardSelectModalCardsComponent tr:hover{
  cursor: pointer;
}
</style>